<div class="ui-profile-menu">
  <h2 class="ui-profile-menu__heading">{{ title() }}</h2>

  <div class="ui-profile-menu__user">
    <ui-avatar
      class="ui-profile-menu__avatar"
      [imageSrc]="avatarSrc()"
      [label]="avatarLabel()"
      [iconSrc]="avatarIconSrc()"
      [imageAlt]="avatarAlt()"
      [ariaLabel]="avatarAlt() || userName()"
      size="lg"
      shape="circle"
      tone="neutral"
    />
    <div class="ui-profile-menu__meta">
      <span class="ui-profile-menu__name">{{ userName() }}</span>
      @if (userRole()) {
        <span class="ui-profile-menu__role">{{ userRole() }}</span>
      }
      @if (userEmail()) {
        <span class="ui-profile-menu__email-row">
          <span class="ui-profile-menu__email-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
          </span>
          <span class="ui-profile-menu__email">{{ userEmail() }}</span>
        </span>
      }
    </div>
  </div>

  <div class="ui-profile-menu__divider" role="separator"></div>

  <ul class="ui-profile-menu__list" role="list">
    @for (item of resolvedItems(); track item.id) {
      <li role="listitem">
        <button type="button" class="ui-profile-menu__item" (click)="onItemClick(item.id)">
          <span class="ui-profile-menu__item-icon-wrap" aria-hidden="true">
            @if (item.iconSrc) {
              <img class="ui-profile-menu__item-icon-img" [src]="item.iconSrc" alt="" />
            } @else {
              @switch (resolveIcon(item)) {
                @case ('user') {
                  <svg class="ui-profile-menu__item-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                }
                @case ('notes') {
                  <svg class="ui-profile-menu__item-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                }
                @case ('tasks') {
                  <svg class="ui-profile-menu__item-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7" height="7" />
                    <rect x="14" y="3" width="7" height="7" />
                    <rect x="14" y="14" width="7" height="7" />
                    <rect x="3" y="14" width="7" height="7" />
                  </svg>
                }
              }
            }
          </span>
          <span class="ui-profile-menu__item-text">
            <span class="ui-profile-menu__item-title">{{ item.title }}</span>
            <span class="ui-profile-menu__item-sub">{{ item.subtitle }}</span>
          </span>
        </button>
      </li>
    }
  </ul>

  <ui-button
    class="ui-profile-menu__logout"
    variant="primary"
    [block]="true"
    type="button"
    (pressed)="onLogout()"
  >
    {{ logoutLabel() }}
  </ui-button>
</div>
